module.exports = __webpack_public_path__ + "img/vn4-housing-and-transportation.83a119d8.jpg";